import React from 'react';
import SVG from 'react-inlinesvg';
import { useDrag } from 'react-dnd';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

export function GeoAnchorCard({ id, top, left, setDragging }) {
  const [{ isDragging }, drag, dragPreview] = useDrag(
    {
      item: {
        type: 'THING',
        id: id,
        top: top,
        left: left,
      },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    },
    [id, left, top]
  );

  const isDragged = left === 0;

  return isDragging ? (
    <div ref={dragPreview} className={`geo-anchor-card fill-width dragging`}>
      <div style={{ width: '20%' }} className="m-2 text-center">
        <span className="svg svg-icon menu-icon">
          <SVG
            uniquifyIDs
            src={toAbsoluteUrl('/media/svg/senseworks/geo-anchor.svg')}
          />
        </span>
      </div>
      <span className="text-white">Geo Anchor</span>
    </div>
  ) : (
    <div
      className={`geo-anchor-card ${isDragged ? 'fill-width' : ''}`}
      ref={drag}
      id={id}
      {...isDragging}
      onDragStart={() => {
        setDragging(true);
      }}
      onDragEnd={() => {
        setDragging(false);
      }}
    >
      <div style={{ width: '20%' }} className="m-2 text-center">
        <span className={`svg svg-icon menu-icon`}>
          <SVG
            uniquifyIDs
            src={toAbsoluteUrl('/media/svg/senseworks/geo-anchor.svg')}
          />
        </span>
      </div>
      {!isDragged ? null : <span className="text-white">Geo Anchor</span>}
    </div>
  );
}

export function ThingCard({ top, setDragging, setSelectedThing, ...rest }) {
  const [{ isDragging }, drag, dragPreview] = useDrag(
    {
      item: {
        type: 'THING',
        id: rest.id,
        top: top,
        left: 15,
      },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    },
    [rest.id, top]
  );

  return isDragging ? (
    <div ref={dragPreview} className={`thing-card fill-width dragging`}>
      <div style={{ width: '20%' }} className="m-2 text-center">
        <span className={`svg svg-icon menu-icon`}>
          <SVG
            uniquifyIDs
            src={toAbsoluteUrl('/media/svg/senseworks/anchor.svg')}
          />
        </span>
      </div>
      <span className="text-white"> {rest.attributes.serialNumber} </span>
    </div>
  ) : (
    <div
      className={`thing-card fill-width`}
      ref={drag}
      id={rest.id}
      {...isDragging}
      onDragStart={() => {
        setSelectedThing(rest);
        setDragging(true);
      }}
      onDragEnd={() => {
        setDragging(false);
      }}
    >
      <div style={{ width: '20%' }} className="m-2 text-center">
        <span className={`svg svg-icon menu-icon`}>
          <SVG
            uniquifyIDs
            src={toAbsoluteUrl('/media/svg/senseworks/anchor.svg')}
          />
        </span>
      </div>
      <div className="d-flex flex-column">
        <span className="text-white"> {rest.attributes.serialNumber} </span>
        <span style={{ fontSize: '.9rem', color: '#767676' }}>
          {' '}
          {rest.model?.toUpperCase()}{' '}
        </span>
      </div>
    </div>
  );
}

export function InstalledThingCard({ thing, onClick }) {
  return (
    <div
      className={`installed-thing-card fill-width`}
      id={thing.id}
      onClick={onClick}
    >
      <div style={{ width: '20%' }} className="m-2 text-center">
        <span className={`svg svg-icon menu-icon`}>
          <SVG
            uniquifyIDs
            src={toAbsoluteUrl('/media/svg/senseworks/anchor.svg')}
          />
        </span>
      </div>
      <div className="d-flex flex-column">
        <span className="text-white"> {thing.attributes.serialNumber} </span>
        <span style={{ fontSize: '.9rem', color: '#767676' }}>
          {' '}
          {thing.model?.toUpperCase()}{' '}
        </span>
      </div>
    </div>
  );
}
